module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "media-edit-album"
    }
  }, [_c('h2', [_vm._v("Edit Album Details")]), _vm._v(" "), (!_vm.savingAlbum && !_vm.deleteMode) ? _c('form', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.albumName),
      expression: "albumName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Album Name"
    },
    domProps: {
      "value": (_vm.albumName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.albumName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("\n            Album Cover Art "), _c('input', {
    attrs: {
      "type": "file",
      "name": "avatar",
      "accept": "image/*"
    },
    on: {
      "change": _vm.updateUploadedAlbumName
    }
  }), _vm._v(" "), (_vm.uploadedImageSrc) ? _c('div', {
    staticClass: "albumPreview",
    style: (("background-image: url('" + _vm.uploadedImageSrc + "')"))
  }) : _vm._e(), _vm._v(" "), (_vm.albumImageTooBig) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v("Maximum filesize of an Album Icon is 10Mb")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editAlbum($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterDeleteMode($event)
      }
    }
  }, [_vm._v("Delete Album")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isValidated()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editAlbum($event)
      }
    }
  }, [_vm._v("Save Changes")])]) : _vm._e(), _vm._v(" "), (_vm.deleteMode) ? [_c('h1', [_vm._v("Are you sure you want to delete this album and all the media pieces inside it?")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitDeleteMode($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteAlbum($event)
      }
    }
  }, [_vm._v("Delete Album")])] : _vm._e(), _vm._v(" "), (_vm.savingAlbum) ? _c('saver-large') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74a7ef6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Media/FormEditMediaAlbum.vue
// module id = 890
// module chunks = 2